import { useQuery } from "@apollo/client";
import { GetUnhandledExternalCasesDocument } from "../../gql/generated/graphql";

export const useExternalCasesList = () => {
  const { data, loading, refetch } = useQuery(
    GetUnhandledExternalCasesDocument
  );

  return {
    unhandledExternalCases: data?.getUnhandledExternalCases ?? [],
    isLoading: loading,
    refetch: refetch,
  };
};
